const SubLocation = {

    // FIELDS
    "sub_location": "Sub Location",
    "name": "Name",
    "description": "Description",
    "location": "Location",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Sub Location",
    "filter_title": "Sub Location Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_location": "Location",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Sub Location Name",
    "error_description": "Enter Description",
    "error_location": "Select Location",
    "error_status": "Select Status",

}

export default SubLocation;

